import { render } from "./select_hotel_content.vue?vue&type=template&id=708de383"
import script from "./select_hotel_content.vue?vue&type=script&lang=js"
export * from "./select_hotel_content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__